import React from 'react';
import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { ArrowRightIcon, EnvelopeIcon, IconText, PhoneIcon, ShieldIcon, VerifiedIcon } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';
import { formatPhoneNumber } from 'Utilities/helpers';

import { Modal } from 'Storybook/components/local/Modal/Modal';

import LocalTexts from './DealershipDetailsModal.texts.json';

import styles from './DealershipDetailsModal.scss';

const LocalT = new MDText(LocalTexts);

export const contactUsLink = 'https://help.motorway.co.uk/hc/en-gb/requests/new?ticket_form_id=12243455399836';

const contactLink = <span className={styles.contactLinkText}>
  <p className={styles.linkHeader}>{LocalT.translate('contactLink.header')}</p>
  <p className={styles.linkSubtext}>{LocalT.translate('contactLink.subtext')}</p>
</span>;

export type DealershipDetails = {
  contactEmail?: string;
  contactNumber?: string;
  name: string;
}

export type DealershipDetailsModalProps = {
  dealership: DealershipDetails;
  isSaleDetailsPage?: boolean;
  onCloseModalClick: () => void;
}

export const DealershipDetailsModal = (
  {
    dealership,
    isSaleDetailsPage = false,
    onCloseModalClick,
  }: DealershipDetailsModalProps,
) => {
  const { contactEmail, contactNumber, name } = dealership ?? {};

  const dealershipPhoneNumber = formatPhoneNumber(contactNumber).pretty;

  return <Modal
    centered
    className={styles.container}
    contentClass={styles.modalContent}
    dialogClass={styles.modal}
    dismissModal={onCloseModalClick}
    shouldCloseOnEsc={true}
    shouldCloseOnOverlayClick={true}
    size="small"
    withCloseButton={true}
  >
    <h3 className={styles.heading}>
      {name}
    </h3>
    <ul className={styles.details}>
      <li className={styles.verified}>
        <IconText
          icon={VerifiedIcon}
          text={LocalT.translate('verifiedDealership')}
          variant="small--regular" />
      </li>
      {contactEmail && <li>
        <IconText
          icon={EnvelopeIcon}
          text={<Hyperlink
            href={`mailto:${contactEmail}`}
            label={contactEmail}
            onClick={() => POST_SALE_SNOW_PLOW_EVENTS.DEALER_DETAILS_MODAL_EMAIL_CLICKED(isSaleDetailsPage)}
            variant='secondary' />}
          variant="small--regular" />
      </li>}
      {contactNumber && <li>
        <IconText
          icon={PhoneIcon}
          text={<Hyperlink
            href={`tel:${contactNumber}`}
            label={dealershipPhoneNumber}
            onClick={() => POST_SALE_SNOW_PLOW_EVENTS.DEALER_DETAILS_MODAL_PHONE_NUMBER_CLICKED(isSaleDetailsPage)}
            variant='secondary' />}
          variant="small--regular" />
      </li>}
      <li>
        <Link
          className={styles.contactLink}
          onClick={() => POST_SALE_SNOW_PLOW_EVENTS.NEED_HELP_SALE_COLLECTION_CTA_CLICK(
            { isSaleDetailsPage, url: contactUsLink },
          )}
          rel="noreferrer noopener"
          target='_blank'
          to={{ pathname: contactUsLink }}
        >
          <IconText
            icon={ShieldIcon}
            text={contactLink}
            variant="small--regular" />
          <ArrowRightIcon />
        </Link>
      </li>
    </ul>
  </Modal>;
};
